var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarOutline = function SvgStarOutline(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "-6 -6 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20 7.74-7.19-.62L10 .5 7.19 7.13 0 7.74l5.46 4.73-1.64 7.03L10 15.77l6.18 3.73-1.63-7.03L20 7.74ZM10 13.9l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L10 4.6l1.71 4.04 4.38.38-3.32 2.88 1 4.28L10 13.9Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarOutline);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9Ii02IC02IDMyIDMyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMjAgNy43NEwxMi44MSA3LjEyTDEwIDAuNUw3LjE5IDcuMTNMMCA3Ljc0TDUuNDYgMTIuNDdMMy44MiAxOS41TDEwIDE1Ljc3TDE2LjE4IDE5LjVMMTQuNTUgMTIuNDdMMjAgNy43NFpNMTAgMTMuOUw2LjI0IDE2LjE3TDcuMjQgMTEuODlMMy45MiA5LjAxTDguMyA4LjYzTDEwIDQuNkwxMS43MSA4LjY0TDE2LjA5IDkuMDJMMTIuNzcgMTEuOUwxMy43NyAxNi4xOEwxMCAxMy45WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";